__turbopack_context__.v({
  "root": "Icon-system-module__My55ma__root",
});
